import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    textAlign: "center"
  }
}));
